import { FormattedMessage, useIntl } from 'react-intl';
import { Button } from '@/components/ui/button';
import { signInInput } from './styles';

type Props = {
  email: string;
  onEmailChange: (value: string) => void;
  onSubmit: () => void;
  isPending: boolean;
  error: string | null;
};

const EmailStep = ({
  email,
  onEmailChange,
  onSubmit,
  isPending,
  error,
}: Props) => {
  const { formatMessage } = useIntl();

  return (
    <>
      <div className="tw:mb-6">
        <input
          autoFocus
          id="email"
          type="email"
          value={email}
          onChange={(e) => onEmailChange(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') onSubmit();
          }}
          placeholder={formatMessage({
            id: 'sign-in-email-placeholder',
            defaultMessage: 'Your email',
          })}
          className={signInInput(!!error)}
        />
        {error && (
          <p className="tw:mt-2 tw:text-sm tw:text-destructive tw:text-center">
            {error}
          </p>
        )}
      </div>
      <Button
        type="button"
        size="lg"
        onClick={onSubmit}
        disabled={isPending}
        className="tw:w-48 tw:rounded-full"
      >
        <FormattedMessage
          id="sign-in-form-continue"
          defaultMessage="Continue"
        />
      </Button>
    </>
  );
};

export default EmailStep;
